<template>
  <div class="root-box">
    <div class="query-container space-between">
      <div>
        <el-form size="small" :inline="true">
          <el-form-item label="号码：" @change="query" prop="userTel">
            <el-input v-model="param.userTel" clearable></el-input>
          </el-form-item>

          <el-form-item>
            <el-button style="width: 100px; margin-right: 20px" type="primary" @click="query"
              >查询</el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <div>
        <el-button type="primary" :size="size" @click="openBindCustomAxb" style="width: 80px"
          >绑定隐号</el-button
        >
      </div>
    </div>

    <!-- 修改数据对话框  @close="addDataClosed -->
    <el-dialog
      :visible.sync="visible"
      width="600px"
      max-height="600"
      :size="size"
      title="绑定隐号"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form" :size="size" label-width="120px" :rules="rules">
        <el-form-item label="乘客号码：" prop="userNumber">
          <el-input v-model="form.userNumber"></el-input>
        </el-form-item>

        <el-form-item label="司机号码：" prop="driverNumber">
          <el-input v-model="form.driverNumber"></el-input>
        </el-form-item>

        <el-form-item label="备注：" prop="remark">
          <el-input type="textarea" :rows="3" v-model="form.remark"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer">
        <el-button type="warning" :size="size" @click="bindCustomAxbFun">绑定</el-button>
        <el-button type="info" :size="size" @click="closeDiag">取 消</el-button>
      </span>
    </el-dialog>

    <div class="table">
      <el-table :data="list" stripe max-height="650">
        <el-table-column
          type="index"
          label="序号"
          show-overflow-tooltip
          width="100"
        ></el-table-column>
        <el-table-column prop="axbNumber" label="隐私号码"> </el-table-column>
        <el-table-column prop="userNumber" label="乘客号码"></el-table-column>
        <el-table-column prop="driverNumber" label="司机号码"></el-table-column>
        <el-table-column prop="remark" label="备注"></el-table-column>

        <el-table-column label="通话记录">
          <template slot-scope="scope">
            <tel-record
              :userTel="scope.row.userNumber"
              :prinum="scope.row.axbNumber"
              :orderId="1"
              :status="scope.row.prinumBindStatus"
              :bindId="scope.row.prinumId"
              :type="5"
              :queryKey="scope.row.prinumId"
              :isContacted="false"
            >
              <el-button type="text" size="small">通话记录</el-button>
            </tel-record>
          </template>
        </el-table-column>

        <el-table-column prop="prinumBindStatus" label="绑定状态">
          <template slot-scope="scope">
            {{
              scope.row.prinumBindStatus == 1
                ? "绑定成功"
                : scope.row.prinumBindStatus == 2
                ? "已联系"
                : "解绑"
            }}
          </template>
        </el-table-column>

        <el-table-column prop="createTime" label="创建时间"></el-table-column>
        <el-table-column prop="opts" label="操作">
          <template slot-scope="scope">
            <span>
              <el-button type="text" size="small" @click="unbindCustomAxbFun(scope.row.id)"
                >解绑</el-button
              >
            </span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { listCustomPrinum, bindCustomAxb, unbindCustomAxb } from "@/api";
import { mapState } from "vuex";
import TelRecord from "@/components/TelCell/TelRecord";
const telReg = /^1\d{10}$/;
export default {
  components: {
    TelRecord
  },
  created() {
    this.query();
  },
  computed: {
    ...mapState({
      size: (state) => state.btnSize,
      prinumTypeOpts: (state) => state.enumMap["PRINUM_TYPE"]
    })
  },
  data() {
    return {
      visible: false,
      param: {},
      form: {},
      list: [],
      rules: {
        userNumber: [
          { required: true, message: "乘客号码不能为空", trigger: "blur" },
          {
            pattern: telReg,
            message: "请输入正确的手机号码",
            trigger: "change"
          }
        ],
        driverNumber: [
          { required: true, message: "司机号码不能为空", trigger: "blur" },
          {
            pattern: telReg,
            message: "请输入正确的手机号码",
            trigger: "change"
          }
        ],
        remark: [{ required: true, message: "备注不能为空，请说明绑定原因", trigger: "blur" }]
      }
    };
  },
  methods: {
    query() {
      listCustomPrinum(this.param.userTel).then((res) => {
        this.list = res.data || [];
      });
    },
    closeDiag() {
      this.visible = false;
    },

    openBindCustomAxb() {
      this.visible = true;
      this.form = {
        // userNumber: "15527616552",
        // driverNumber: "15527616553"
      };
    },

    bindCustomAxbFun() {
      //表单校验结果为false 直接返回
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        bindCustomAxb(this.form).then(() => {
          this.$message.success("绑定成功");
          this.visible = false;
          this.query();
        });
      });
    },
    unbindCustomAxbFun(id) {
      unbindCustomAxb(id).then((res) => {
        if (res.data === true) {
          this.$message.success("解绑成功");
        } else {
          this.$message.success("未解绑成功");
        }
        this.query();
      });
    }
  }
  //methods
};
</script>

<style scoped lang="less">
.table {
  margin: 20px 0;
}

.page {
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;
}
</style>
